import type from './user-clicked-stop.type';

const userClickedStop = () => ({ type });

export default userClickedStop;
